import { defineComponent as _defineComponent } from 'vue'
import { escapeContent, removeParagraphsFromListItems } from '@/ui/helpers/rteHelper';
  import { BulletList } from '@tiptap/extension-bullet-list';
  import { Document } from '@tiptap/extension-document';
  import { Dropcursor } from '@tiptap/extension-dropcursor';
  import { Gapcursor } from '@tiptap/extension-gapcursor';
  import { History } from '@tiptap/extension-history';
  import Link from '@tiptap/extension-link';
  import ListItem from '@tiptap/extension-list-item';
  import { OrderedList } from '@tiptap/extension-ordered-list';
  import { Text } from '@tiptap/extension-text';
  import TextStyle from '@tiptap/extension-text-style';
  import Underline from '@tiptap/extension-underline';
  import { Editor, EditorContent } from '@lumiform/tiptap-vue-2';
  import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
  import EditorToolbar from './EditorToolbar.vue';
  import Bold from './plugins/Bold';
  import Color from './plugins/Color';
  import Italic from './plugins/Italic';
  import Highlight from './plugins/Highlight';
  import Paragraph from './plugins/Paragraph';
  import Strike from './plugins/Strike';
  import Placeholder from '@tiptap/extension-placeholder';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Editor',
  props: {
    value: {
      type: String,
      default: '',
    },
    escapeOnInit: {
      type: Boolean,
    },
    placeholder: {
      type: String,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['input'],
  setup(__props, { expose, emit }) {

const props = __props;

  

  

  const editor = ref<Editor | null>(null);

  onMounted(() => {
    //@ts-ignore
    editor.value = new Editor({
      content: props.escapeOnInit ? escapeContent(props.value) : props.value,
      editable: props.editable,
      extensions: [
        BulletList,
        Document,
        Dropcursor,
        Gapcursor,
        History,
        ListItem,
        OrderedList,
        Text,
        Paragraph,
        Bold,
        Italic,
        Strike,
        TextStyle,
        Color,
        Link.configure({
          HTMLAttributes: {
            rel: null,
            target: null,
          },
        }),
        Highlight,
        Underline,
        Placeholder.configure({
          placeholder: props.placeholder,
        }),
      ],
      onUpdate: () => {
        const html = removeParagraphsFromListItems(editor.value!.getHTML());
        emit('input', html);
      },
    });

    watch(() => props.value, newValue => {
      if (newValue !== removeParagraphsFromListItems(editor.value!.getHTML())) {
        editor.value!.commands.setContent(newValue || '');
      }
    });

    watch(() => props.editable, newEditable => {
      editor.value!.setEditable(newEditable);
    });
  });

  const focus = () => {
    editor.value!.view.dom.focus({ preventScroll: true });
  };

  expose({
    focus,
  });

  onBeforeUnmount(() => {
    editor.value!.destroy();
  });

return { __sfc: true,props, emit, editor, focus, EditorContent, EditorToolbar }
}

})